import { render, staticRenderFns } from "./TreatmentLineCard.vue?vue&type=template&id=2007231f&scoped=true&"
import script from "./TreatmentLineCard.vue?vue&type=script&lang=ts&"
export * from "./TreatmentLineCard.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentLineCard.vue?vue&type=style&index=0&id=2007231f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007231f",
  null
  
)

export default component.exports